import { Divider } from "antd";
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { routes_data } from "../../constants/StaticData";
import { FormattedMessage } from "react-intl";
import { Box, Flex } from "@chakra-ui/react";
import { FaSignOutAlt } from "react-icons/fa";
import { RxDashboard } from "react-icons/rx";

export const HamMenu = ({ handleHamMenu, auth }) => {
  return (
    <div className="hamMenu-fixed">
      <Flex justify="space-between" align="center" mb={10}>
        <img
          src="/icons/sandseeker_logo.svg"
          alt="logo"
          style={{ width: "140px" }}
        />
        <Box onClick={handleHamMenu} cursor="pointer" p={2}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </Box>
      </Flex>

      <div className="ham-menu-content">
        {routes_data?.map((route) => {
          return (
            <div className="ham-item-container" key={route?.name}>
              {route?.isRoute ? (
                <Link
                  to={route?.path}
                  onClick={handleHamMenu}
                  className="ham-link-style"
                >
                  <FormattedMessage id={route?.name} />
                </Link>
              ) : (
                <a
                  href={route?.path}
                  onClick={handleHamMenu}
                  className="ham-link-style"
                >
                  <FormattedMessage id={route?.name} />
                </a>
              )}
              <Divider className="ham-divider" />
            </div>
          );
        })}

        {auth && (
          <>
            <div className="ham-item-container">
              <Link
                to="/user-dashboard"
                onClick={handleHamMenu}
                className="ham-link-style"
                style={{ color: "#e5be54", display: "flex", alignItems: "center", gap: "10px" }}
              >
                <RxDashboard size={20} />
                <FormattedMessage id="view_dashboard" />
              </Link>
              <Divider className="ham-divider" />
            </div>
            <div className="ham-item-container">
              <Box
                onClick={() => {
                  localStorage.removeItem("userData");
                  window.location.replace("/");
                }}
                className="ham-link-style"
                cursor="pointer"
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <FaSignOutAlt size={20} />
                <FormattedMessage id="Logout" />
              </Box>
              <Divider className="ham-divider" />
            </div>
          </>
        )}
      </div>
    </div>
  );
};
